export const PRELOAD_TECHNOCOIN_FLAG = 'preloadTechnocoin3d';

export const shouldPreloadTechnocoin = (): boolean => {
  try {
    return localStorage.getItem(PRELOAD_TECHNOCOIN_FLAG) === '1';
  } catch {
    return false;
  }
};

export const setOwnerPreloadFlag = (): void => {
  try {
    localStorage.setItem(PRELOAD_TECHNOCOIN_FLAG, '1');
  } catch {
    return;
  }
};

export const clearOwnerPreloadFlag = (): void => {
  try {
    localStorage.removeItem(PRELOAD_TECHNOCOIN_FLAG);
  } catch {
    return;
  }
};
